import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '../../product/components/templates/Layout'
import DropdownManage from '../../product/views/Dynamic/dropdown'
const Condition = () => {
    return (
        <Layout>
            <div className="dashboard staticPages">
                <DropdownManage
                    name={'conditionTypeId'}
                    subLevel={0}
                    subField={null}
                />
            </div>
        </Layout>
    )
}
export default Condition
